export { default } from "./FeaturedProducts.jsx";
